import React, { useCallback } from 'react'

import Step from '../../../../../../../features/components/Forms/StepForm/Step'

import { START_DATE, END_DATE } from '../../../../../../ReusableFormFields/StartEndDateRangeFields/fields'

import StartAndEndDatesLimitedByRightSection from '../../../../../../ReusableFormFields/StartAndEndDatesLimitedByRightSection'

const stepFields = [START_DATE, END_DATE]

const DatesStep = ({ formik, handleStepChange }) => {
  const handleContinue = useCallback(() => {
    handleStepChange(stepFields)
  }, [handleStepChange])

  return (
    <Step stepTitle="What should the start and end dates be?" handleContinue={handleContinue}>
      <StartAndEndDatesLimitedByRightSection formik={formik} />
    </Step>
  )
}

export default DatesStep
